import getNormalizedThreadId from '@/redux/selectors/pieveSelectors/lib/getNormalizedThreadId.js';
import getThreadParentId from '@/redux/selectors/pieveSelectors/lib/getThreadParentId.js';
import getThreadType from '@/redux/selectors/pieveSelectors/lib/getThreadType.js';

const getCurrentAutomationRequestedId = ({ routeRequestedId, activeThreadId, threadMetaByIdValue, ownerThreadType, runThreadType = null, selectedRequestedId = null }) => {
  const normalizedRouteRequestedId = String(routeRequestedId || '').trim();

  if (normalizedRouteRequestedId) {
    return normalizedRouteRequestedId;
  }

  const normalizedActiveThreadId = getNormalizedThreadId(activeThreadId);

  if (normalizedActiveThreadId) {
    const activeThreadMeta = threadMetaByIdValue?.[normalizedActiveThreadId] || null;
    const activeThreadType = getThreadType(activeThreadMeta);

    if (activeThreadType === ownerThreadType) {
      return normalizedActiveThreadId;
    }

    if (runThreadType && activeThreadType === runThreadType) {
      return getThreadParentId(activeThreadMeta);
    }
  }

  return String(selectedRequestedId || '').trim() || null;
};

export default getCurrentAutomationRequestedId;
